const initialState = {
  locales: [],
  selectedLanguage: localStorage.getItem('selectedLanguage') || 'hu',
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOCALES':
      return {
        ...state,
        locales: action.data,
      };

    case 'SET_SELECTED_LANGUAGE':
      localStorage.setItem('selectedLanguage', action.data);

      return {
        ...state,
        selectedLanguage: action.data,
      };

    default:
      return state;
  }
};

export default appReducer;
